import React from "react"
import {useParams, Navigate, NavLink} from "react-router-dom"
import { usePayeeStore } from "../../../contexts/PayeeStoreContext"

import Icon from "../../../components/Icon"
import PlaceOrderButton from "../../../containers/PlaceOrderButton"
import OrderingCheckout from "../../../containers/OrderingCheckout"

import {useSelector} from "react-redux"
import { PAYEE_CATALOG_TYPE_ORDERING } from "../../../constants/payeeCatalog"

const Checkout = ({}) => {
    const {catalogHandleId="", payeeHandleId=""} = useParams()
    const {payeeId="", cartId="", payeeCatalogId=""} = usePayeeStore()
    const cart = useSelector(state => state.carts.cartsById[cartId])
    const payee = useSelector(state => state.payees.payeesById[payeeId])
    const payeeCatalog = useSelector(state => state.payeeCatalogs.payeeCatalogsById[payeeCatalogId])
    //if there is no cart, go back to the catalog
    if (!cart) return <Navigate replace to={`/${payeeHandleId}/c/${catalogHandleId}`} />
    const {name:payeeName="", senderFee=0} = payee || {}
    //get configurations for the specific catalogs that are allowed to use the advanced checkout page
    const {config={}, catalogType=""} = payeeCatalog || {}
    if (![PAYEE_CATALOG_TYPE_ORDERING].includes(catalogType)) return <Navigate replace to={`/${payeeHandleId}/c/${catalogHandleId}/cart`} />
    return (
        <div className="display-flex flex-direction-column flex-1 min-height-100vh">
            <div className="flex-grow-1">
                <div className="h2 padding-1em text-align-center">Review your order from {payeeName}</div>
                <div className="columnLayout">
                    <div className="padding-1em display-flex justify-content-space-between">
                        <div>
                            <div className="margin-bottom-1em cursor-pointer hover-background-light-grey border-radius-8px padding-5px">
                                <NavLink
                                    className="display-flex align-items-center text-decoration-none color-black" 
                                    to={`/${payeeHandleId}/c/${catalogHandleId}/cart`}
                                >
                                    <Icon icon="arrow-back"/> <span className="font-size-14px">Back to cart</span>
                                </NavLink>
                            </div>
                        </div>
                        <button className="button outline">
                            <NavLink to={`/${payeeHandleId}/c/${catalogHandleId}`}>
                                Add more
                            </NavLink>
                        </button>
                    </div>
                    {
                        catalogType === PAYEE_CATALOG_TYPE_ORDERING ?
                        <OrderingCheckout 
                            cartId={cartId}
                            catalogConfig={config[catalogType] || {}}
                            payeeSenderFee={senderFee}
                        />
                        :
                        null
                    }
                </div>
            </div>
            {
                cart ? 
                <div className="block-bottom-bar margin-top-1em">
                    <div className="columnLayout">
                        {/* <div className="display-flex justify-content-space-between font-weight-600">
                            <div>Subtotal</div>
                            <div className="amount">EC ${Number(cartTotalXcd).toFixed(2)}</div>
                        </div> */}
                        <div className="margin-top-05em margin-bottom-05em font-size-11px text-align-justify">By continuing, you agree to share your name, billing information and item list with the merchant. You also agree to receive order updates via phone, sms and email. You agree to our Refund Policy and our Privacy Policy.</div>
                        <PlaceOrderButton 
                            cartId={cartId}
                            payeeId={payeeId}
                            payeeCatalogId={payeeCatalogId}
                            payeeHandleId={payeeHandleId}
                        />
                    </div>
                </div>
                :
                null
            }
        </div>
    )
}

export default Checkout